import { useQuery } from '@tanstack/react-query';
import { collection, getDocs } from 'firebase/firestore';
import firebaseApp from '../firebase-app';
import { FS_PATH_APP_CONFIGS } from '../constants';
import { AppConfigData } from '../types/app-config';
import { useUserAuth } from '../contexts/auth';
import { APP_TYPE } from '../types';
export interface AppConfig {
  data: AppConfigData;
  abbrv: string;
}
export const getAppConfigs = async (): Promise<any[]> => {
  const querySnapshot = await getDocs(collection(firebaseApp.db, FS_PATH_APP_CONFIGS));
  const appConfigs: AppConfig[] = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data() as AppConfigData;
    appConfigs.push({
      abbrv: doc.id,
      data,
    });
  });
  return appConfigs;
};

export function useGetAppConfigs() {
  const { hasTeamAccess } = useUserAuth();
  const res = useQuery({
    queryKey: ['all-app-configs'],
    queryFn: async (): Promise<AppConfig[]> => {
      const res = await getAppConfigs();
      return res.filter(({ abbrv }) => hasTeamAccess(abbrv));
    },
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  return res;
}

export function useAppTeamConfigs() {
  const { hasTeamAccess } = useUserAuth();
  const res = useQuery({
    queryKey: ['all-app-team-configs'],
    queryFn: async (): Promise<AppConfig[]> => {
      const res = await getAppConfigs();
      return res.filter(
        ({ abbrv, data }) => data.appType === APP_TYPE.CLUB && hasTeamAccess(abbrv)
      );
    },
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  return res;
}
